<br>
<div class="table-container">

    <!--filter/button-->
    <div class="control-container">
        <span class="year-select">
            Year: 
            <select class="custom-select" [(ngModel)]="filter" (ngModelChange)="applyFilter()">
                <option class="custom-option" *ngFor="let year of yearList" [ngValue]="year">{{year}}</option>
            </select>
        </span>
        <button mat-raised-button color="primary" [disabled]="!setNextYear" (click)="createNextYear()">Create Next Year Holidays</button>
    </div>

    <!--lambda message-->
    <app-response-text
      class="page-message"
      [lambdaMessage]="lambdaMessage"
      [lambdaError]="lambdaError">
    </app-response-text>

    <!--grid-->
    <app-data-grid
        [(data)]="filteredData"
        (dataChange)="updateLocalData($event)"
        (itemChange)="updateItem();"
        (buttonEvent)="lambdaMessage=''; lambdaError=false;"
        [(isValid)]="formValid"
        [viewTemplate]="view"
        [formTemplate]="formView"
        [footerTemplate]="footer" 
        [columnNames]="['Holiday', 'Start Date', 'Start Time', 'End Date', 'End Time', 'Status']"
        [spacing]="[25, 15, 10, 15, 10, 15, 10]" 
        [itemsPerPage]="10"
        [objectBluePrint]="bluePrint"
        [allowDelete]="false"
        [allowEdit]="canEdit">

        <ng-template #view let-item>
            <td><div class="lefty">{{item.holiday}}</div></td>
            <td>{{displayUS(item.startDate)}}</td>
            <td>{{item.startTime}}</td>
            <td>{{displayUS(item.endDate)}}</td>
            <td>{{item.endTime}}</td>
            <td>{{item.status}}</td>
        </ng-template>

        <ng-template #formView let-item>
            <td><input type="text" [(ngModel)]="item.holiday" (ngModelChange)="formValid = validate(item)"></td>
            <td><input type="date" [(ngModel)]="item.startDate" (ngModelChange)="item.endDate = item.startDate; formValid = validate(item);" ></td>
            <td><input type="time" [(ngModel)]="item.startTime" (ngModelChange)="formValid = validate(item)"></td>
            <td><input type="date" [(ngModel)]="item.endDate" (ngModelChange)="formValid = validate(item)"></td>
            <td><input type="time" [(ngModel)]="item.endTime" (ngModelChange)="formValid = validate(item)"></td>
            <td>
                <select class="custom-select" [(ngModel)]="item.status" (ngModelChange)="formValid = validate(item)">
                    <option class="custom-option" value="Enabled">Enabled</option>
                    <option class="custom-option" value="Disabled">Disabled</option>
                </select>
            </td>
        </ng-template>

        <ng-template #footer>
            <div class="banner">
                <span class="banner-item">All times are in EST (UTC -5)</span>
                <span class="banner-item">Time Format: Military Time</span>
            </div>
        </ng-template>
    
    </app-data-grid>
    <br>

</div>